import { z } from "zod"

export const SavedContactSchema = z.object({
    id: z.string(),
    workspaceId: z.string(),
    name: z.string(),
    email: z.string().optional(),
    phone: z.string().optional(),
    createdAt: z.string(),
    updatedAt: z.string(),
})

export type SavedContact = z.infer<typeof SavedContactSchema>
